// ...existing code from ProtectedRoute.tsx
/**
 * Protected Route Component
 * Ensures user is authenticated before rendering children
 */

import React, { useEffect, useState } from 'react';
import { AuthService } from '@/services/auth.service';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const authenticated = await AuthService.isAuthenticated();
      setIsAuthenticated(authenticated);
      
      if (!authenticated) {
        // Authentication is handled by App.tsx - it will show UserLogin component
        console.log('User not authenticated. App.tsx will handle login flow.');
      }
    } catch (error) {
      console.error('Authentication check failed:', error);
      setIsAuthenticated(false);
    }
  };

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Authenticated
  if (isAuthenticated) {
    return <>{children}</>;
  }

  // Not authenticated - App.tsx will handle showing UserLogin
  return null;
};

export default ProtectedRoute;
